const SHOP_STORAGE_KEY = "rental_shop_domain";

export function normalizeShopDomain(raw) {
  const value = String(raw || "").trim();
  if (!value) return "";
  return value.endsWith(".myshopify.com") ? value : `${value}.myshopify.com`;
}

export function decodeShopFromHostParam(hostParam) {
  try {
    if (!hostParam) return "";
    const decoded = atob(hostParam);
    const url = decoded.startsWith("http")
      ? new URL(decoded)
      : new URL(`https://${decoded}`);

    const queryShop = url.searchParams.get("shop");
    if (queryShop) return normalizeShopDomain(queryShop);

    if (url.hostname && url.hostname.endsWith(".myshopify.com")) {
      return url.hostname;
    }

    const match = url.pathname.match(/\/store\/([^/]+)/i);
    if (match?.[1]) return normalizeShopDomain(match[1]);
  } catch {
    // ignore
  }
  return "";
}

export function readStoredShop() {
  try {
    return sessionStorage.getItem(SHOP_STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function writeStoredShop(value) {
  try {
    if (value) sessionStorage.setItem(SHOP_STORAGE_KEY, value);
  } catch {
    // ignore
  }
}

export function getShopFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const shopParam = params.get("shop");
    if (shopParam) {
      const normalized = normalizeShopDomain(shopParam);
      writeStoredShop(normalized);
      return normalized;
    }

    const hostParam = params.get("host");
    if (hostParam) {
      const decoded = decodeShopFromHostParam(hostParam);
      if (decoded) {
        writeStoredShop(decoded);
        return decoded;
      }
    }

    return readStoredShop();
  } catch {
    return readStoredShop();
  }
}
